(function () {
  var cfg = window.DREYER_FREE_SHIPPING;
  if (!cfg || !cfg.threshold) return;
  var total = null, count = 0, timer = null, loading = false, pending = false;

  function money(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function barHtml() {
    var left = Math.max(0, cfg.threshold - total);
    var pct = Math.min(100, (total / cfg.threshold) * 100);
    var text = left > 0
      ? 'Noch <strong>' + money(left) + '</strong> bis zum kostenlosen Versand'
      : '<strong>Ihr Versand ist kostenlos</strong>';
    return '<p class="cart-progress__text">' + text + '</p>' +
      '<div class="cart-progress__track" role="progressbar" aria-valuemin="0" aria-valuemax="100" aria-valuenow="' + Math.round(pct) + '" aria-label="Fortschritt bis zum kostenlosen Versand">' +
      '<span class="cart-progress__fill" style="width:' + pct + '%"></span></div>';
  }

  function mount(anchor, where) {
    var parent = anchor.parentNode;
    var bar = parent.querySelector(':scope > .cart-progress');
    if (count === 0) { if (bar) bar.remove(); return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'cart-progress';
      bar.setAttribute('aria-live', 'polite');
      anchor.insertAdjacentElement(where, bar);
      bar.innerHTML = barHtml();
      return;
    }
    var fill = bar.querySelector('.cart-progress__fill');
    var nextPct = Math.min(100, (total / cfg.threshold) * 100) + '%';
    var tmp = document.createElement('div');
    tmp.innerHTML = barHtml();
    var newText = tmp.querySelector('.cart-progress__text').innerHTML;
    var textEl = bar.querySelector('.cart-progress__text');
    if (textEl.innerHTML !== newText) textEl.innerHTML = newText;
    if (fill.style.width !== nextPct) fill.style.width = nextPct;
    bar.querySelector('.cart-progress__track').setAttribute('aria-valuenow', Math.round(parseFloat(nextPct)));
  }

  function render() {
    if (total === null) return;
    var drawerHeader = document.querySelector('#CartDrawer .drawer__header');
    if (drawerHeader) mount(drawerHeader, 'afterend');
    var pageTitle = document.querySelector('cart-items .title-wrapper-with-link');
    if (pageTitle) mount(pageTitle, 'afterend');
  }

  function load() {
    if (loading) { pending = true; return; }
    loading = true;
    fetch(window.routes.cart_url + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { total = cart.total_price; count = cart.item_count; render(); })
      .catch(function () {})
      .finally(function () {
        loading = false;
        if (pending) { pending = false; load(); }
      });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(load, 120);
  }

  function isOwn(rec) {
    var el = rec.target.nodeType === 1 ? rec.target : rec.target.parentElement;
    if (el && el.closest && el.closest('.cart-progress')) return true;
    var nodes = [].slice.call(rec.addedNodes).concat([].slice.call(rec.removedNodes));
    return nodes.length > 0 && nodes.every(function (n) { return n.classList && n.classList.contains('cart-progress'); });
  }

  function init() {
    load();
    var targets = [document.getElementById('cart-icon-bubble'), document.getElementById('CartDrawer'), document.querySelector('cart-items')];
    var mo = new MutationObserver(function (records) {
      if (records.every(isOwn)) return;
      render();
      schedule();
    });
    targets.forEach(function (t) { if (t) mo.observe(t, { childList: true, subtree: true }); });
  }

  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
